exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.title[data-v-0eb013b4] {\n  border-bottom: 8px solid #147399;\n}\n", "", {"version":3,"sources":["/Users/fabianspring/Documents/projects/omyfu/omyfu-spa-vue/src/components/home/HomeTitleComponent.vue","/Users/fabianspring/Documents/projects/omyfu/omyfu-spa-vue/src/assets/scss/custom/vars.scss"],"names":[],"mappings":";AAiBA;EACI,iCClBe;CDmBlB","file":"HomeTitleComponent.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../assets/scss/custom/vars';\n.title {\n    border-bottom: 8px solid $omyfu-red;\n}\n","$omyfu-red: #147399;\n$omyfu-yellow: #DEA841;\n$omyfu-hover: #B69658;\n\n$omyfu-grey: #C1C1C1;\n$omyfu-font-color: #000000;\n$h6-font-size: 7pt;\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eb013b4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/HomeTitleComponent.vue
// module id = gPOk
// module chunks = 1